<template>
  <div class="form-field-doc-hint caption">
    <span v-if="hint" class="gray--text text--darken-1">{{ hint }}</span>
    <a
      v-if="shouldShowDocLink"
      :href="resolvedDocUrl"
      target="_blank"
      rel="noopener"
      class="info--text"
      :class="{ 'ml-1': hint }"
    >{{ linkText }}</a>
  </div>
</template>

<script>
export default {
  name: "FormFieldDocHint",
  props: {
    hint: {
      type: String,
      default: "",
    },
    linkText: {
      type: String,
      required: true,
    },
    showDocLink: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    resolvedDocUrl() {
      return this.$store.state.home?.app?.documentation_link || "";
    },
    shouldShowDocLink() {
      return this.showDocLink && !!this.resolvedDocUrl;
    },
  },
};
</script>
